export const HYPERLINK_DATA_FIELDS = {
    ID: 'data-id',
    IS_TITLE_OVERRIDE: 'data-is-title-override',
    COLOR: 'data-color',
    IS_COLOR_OVERRIDE: 'data-is-color-override',
    ICON: 'data-icon',
    IS_ICON_OVERRIDE: 'data-is-icon-override',
    ICON_OVERRIDE_ID: 'data-icon-override-id',
    IS_VIGNETTE: 'data-is-vignette',
    PERMALINK: 'data-permalink',
    IS_BRANDOWNER_HUBPAGE: 'data-is-brandowner-hubpage',
    QUICK_INSERT: 'data-quick-insert',
    HYPERLINK_TYPE: 'data-hyperlink-type',
};



// WEBPACK FOOTER //
// ./js/utils/consts/hyperlink_data_fields.ts